import { ReactNode } from "react";
import { AdditionalFiltersProvider } from "./additional-filters/AdditionalFiltersProvider";
import { AdvancedSearchProvider } from "./advanced-search/AdvancedSearchProvider";
import { PaginationProvider } from "./pagination/PaginationContext";

export const DashboardParamsProviders = ({
  children,
  storageKey,
  persistInSearchParams,
}: {
  children: ReactNode;
  storageKey: string;
  persistInSearchParams?: boolean;
}) => {
  return (
    <AdvancedSearchProvider
      persistInSearchParams={persistInSearchParams}
      storageKey={storageKey}
    >
      <PaginationProvider
        persistInSearchParams={persistInSearchParams}
        storageKey={storageKey}
      >
        <AdditionalFiltersProvider
          persistInSearchParams={persistInSearchParams}
          storageKey={storageKey}
        >
          {children}
        </AdditionalFiltersProvider>
      </PaginationProvider>
    </AdvancedSearchProvider>
  );
};
